module.exports = __webpack_public_path__ + "img/jxjh.ed5974cf.png";